/* Paolina Roma: gift card 3D (snippet pr-gift-card-visual). ES5, nessuna dipendenza.
   - tilt col puntatore (solo dispositivi con hover e mouse, mai con reduced motion)
   - giro della carta al tap / Invio / Spazio (modalita' product)
   - tondino importo che segue la variante scelta nel variant picker di Dawn
   - ingresso animato quando la carta entra nel viewport */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function amountFrom(value) {
    // "€50" / "50 €" / "EUR 50.00" -> "50"
    var m = String(value || '').replace(/[.,]00\b/, '').match(/\d+/);
    return m ? m[0] : '';
  }

  function prices(root) {
    if (root.__pgcPrices) return root.__pgcPrices;
    var el = root.querySelector('[data-pgc-prices]');
    var map = {};
    try {
      map = el ? JSON.parse(el.textContent) : {};
    } catch (e) {
      map = {};
    }
    root.__pgcPrices = map;
    return map;
  }

  function setAmount(root, value) {
    var box = root.querySelector('[data-pgc-amount]');
    var amount = amountFrom(value);
    if (!box || !amount) return;
    var eur = root.getAttribute('data-pgc-eur') === 'true';
    var items = box.querySelectorAll('[data-amount]');
    var target = eur ? box.querySelector('[data-amount="' + amount + '"]') : null;
    var other = box.querySelector('[data-amount="other"]');
    if (!target && other) {
      // valuta diversa dall'euro o taglio senza grafica: prezzo locale come testo
      var label = prices(root)[value] || (eur ? '\u20AC' + amount : '');
      if (!label) return;
      if (other.textContent !== label) other.classList.remove('is-active');
      other.textContent = label;
      target = other;
    }
    if (!target || target.classList.contains('is-active')) return;
    for (var i = 0; i < items.length; i++) items[i].classList.remove('is-active');
    void target.offsetWidth; // riparte l'animazione pop
    target.classList.add('is-active');
  }

  function bindAmount(root) {
    var section = root.closest('product-info, .shopify-section, section');
    if (!section) return;
    var sync = function () {
      var picked = section.querySelector('variant-selects input[type="radio"]:checked, variant-selects select');
      if (picked) setAmount(root, picked.value);
    };
    section.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) sync();
    });
    sync();
  }

  function bindFlip(root) {
    var card = root.querySelector('[data-pgc-card]');
    var stage = root.querySelector('[data-pgc-stage]');
    if (!card || !stage) return;
    var float = card.parentNode;
    var timer = 0;
    // Il clic si ascolta sullo stage: col tilt la parte della carta sotto il mouse va
    // dietro al piano di .pgc-float, che vince l'hit test. Da tastiera il click del
    // bottone risale fin qui, quindi un solo listener copre mouse, touch e tastiera.
    stage.addEventListener('click', function () {
      var on = !card.classList.contains('is-flipped');
      // durante il giro niente transizione "tilt" da 0.14s: il giro resta morbido
      card.classList.remove('is-tilting');
      card.classList.add('is-flipping');
      clearTimeout(timer);
      timer = setTimeout(function () {
        card.classList.remove('is-flipping');
        if (root.__pgcHover) card.classList.add('is-tilting');
      }, 900);
      card.classList.toggle('is-flipped', on);
      float.classList.toggle('is-flipped', on);
      card.setAttribute('aria-label', card.getAttribute(on ? 'data-label-back' : 'data-label-front'));
    });
  }

  function bindTilt(root) {
    if (reduce || !fine) return;
    var stage = root.querySelector('[data-pgc-stage]');
    var cards = root.querySelectorAll('[data-pgc-tilt]');
    if (!stage || !cards.length) return;
    var max = root.getAttribute('data-pgc-mode') === 'promo' ? 7 : 11;
    var raf = 0;
    var last = null;

    function apply() {
      raf = 0;
      if (!last) return;
      var r = stage.getBoundingClientRect();
      var px = Math.min(Math.max((last.x - r.left) / r.width, 0), 1);
      var py = Math.min(Math.max((last.y - r.top) / r.height, 0), 1);
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        c.style.setProperty('--pgc-ry', ((px - 0.5) * 2 * max).toFixed(2) + 'deg');
        c.style.setProperty('--pgc-rx', ((0.5 - py) * 2 * max).toFixed(2) + 'deg');
        c.style.setProperty('--pgc-gx', (px * 100).toFixed(1) + '%');
        c.style.setProperty('--pgc-gy', (py * 100).toFixed(1) + '%');
      }
    }

    stage.addEventListener('pointerenter', function () {
      root.__pgcHover = true;
      for (var i = 0; i < cards.length; i++) {
        if (!cards[i].classList.contains('is-flipping')) cards[i].classList.add('is-tilting');
      }
    });
    stage.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      last = { x: e.clientX, y: e.clientY };
      if (!raf) raf = window.requestAnimationFrame(apply);
    });
    stage.addEventListener('pointerleave', function () {
      last = null;
      root.__pgcHover = false;
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        c.classList.remove('is-tilting');
        c.style.removeProperty('--pgc-rx');
        c.style.removeProperty('--pgc-ry');
        c.style.removeProperty('--pgc-gx');
        c.style.removeProperty('--pgc-gy');
      }
    });
  }

  function bindEntrance(root) {
    if (reduce || !('IntersectionObserver' in window)) {
      root.classList.add('is-in');
      return;
    }
    root.classList.add('is-armed');
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            root.classList.add('is-in');
            io.disconnect();
          }
        }
      },
      { threshold: 0.2 }
    );
    io.observe(root);
    // rete di sicurezza: se l'observer non scatta (pane nascosti, editor) la carta compare comunque
    setTimeout(function () {
      root.classList.add('is-in');
    }, 2500);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-pgc]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.__pgc) continue;
      root.__pgc = true;
      bindEntrance(root);
      bindTilt(root);
      if (root.getAttribute('data-pgc-mode') === 'product') {
        bindFlip(root);
        bindAmount(root);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
